import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0c25846"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full w-11 flex flex-column align-items-center justify-content-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mb-4" }, " 予約の自動振り分け機能が有効な場合、以下のリスト内の優先順位によって予約が自動的に振り分けされます。 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-content-center" }, "データなし", -1))

import { get, set } from "@vueuse/core";
import { ref, computed, watchEffect } from "vue";
import { IStaff } from "@/clinic/typings";


export default /*#__PURE__*/_defineComponent({
  __name: 'Confirm',
  props: {
    staffs: null,
    minHeight: null
  },
  setup(__props: any) {

const props = __props as {
  staffs: IStaff[];
  minHeight: string;
};

const staffList = ref();
const sortDirection = ref("ASC");



const total = computed(() => staffList.value.length);

const onReorder = () => set(sortDirection, sortDirection.value == "ASC" ? "DESC" : "ASC");

const rowIndex = (index: number) => (sortDirection.value == "ASC" ? index + 1 : get(total) - index);

watchEffect(() => {
  set(staffList, props.staffs);
});

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_DataTable, {
      value: staffList.value,
      tableClass: "w-full",
      sortField: "priority",
      sortOrder: 1,
      onValueChange: onReorder,
      scrollable: "",
      scrollHeight: props.minHeight || '0px'
    }, {
      empty: _withCtx(() => [
        _hoisted_3
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "優先度",
          sortable: "",
          sortField: "priority",
          class: "w-3 flex-none"
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(rowIndex(slotProps.index)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "名前",
          class: "w-6 flex-none"
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.name_kanji), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "画像",
          class: "w-3 flex-none flex justify-content-center"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.avatar?.url)
              ? (_openBlock(), _createBlock(_component_Avatar, {
                  key: 0,
                  image: slotProps.data.avatar.url,
                  shape: "circle",
                  class: "flex-shrink-0 mr-2"
                }, null, 8, ["image"]))
              : (_openBlock(), _createBlock(_component_Avatar, {
                  key: 1,
                  icon: "pi pi-user",
                  shape: "circle",
                  class: "flex-shrink-0 mr-2"
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "scrollHeight"])
  ]))
}
}

})